import { atom } from 'recoil';
const getUserIdLocalStorage = () => {
    var _a;
    try {
        const userDatabase = JSON.parse(localStorage.getItem('user-database'));
        return ((_a = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.user) === null || _a === void 0 ? void 0 : _a.id) || 'NO_ID';
    }
    catch (error) {
        return 'NO_ID';
    }
};
const localStorageEffect = (key) => ({ setSelf, onSet }) => {
    const fullKey = `${key}-${getUserIdLocalStorage()}`;
    const savedValue = localStorage.getItem(fullKey);
    if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
    }
    onSet((newValue, _, isReset) => {
        if (isReset) {
            localStorage.removeItem(fullKey);
        }
        else {
            localStorage.setItem(fullKey, JSON.stringify(newValue));
        }
    });
};
export const appTutorialDataAtom = atom({
    key: 'appTutorialDataAtom',
    default: {
        currentView: '',
        skipped: false
    },
    effects_UNSTABLE: [localStorageEffect('tutorial-app')]
});
